import { resolveServiceName } from '../errors/error-messages';
import type { ErrorEntry } from '../../types/error-events-types';

export function formatErrorForCopy(entry: ErrorEntry): string {
  const lines = [
    `[${entry.severity}] ${resolveServiceName(entry.service_origin)} — ${entry.error_code}`,
    new Date(entry.timestamp).toISOString(),
    entry.message,
  ];
  if (entry.occurrenceCount > 1) {
    lines.push(`${entry.occurrenceCount} occurrences`);
  }
  return lines.join('\n');
}

/**
 * A copy-ready bug report for an error (drives the "Report" affordance).
 * Includes the structured `details`/stack so the recipient has the full
 * context, not just the headline.
 */
export function formatErrorReport(entry: ErrorEntry): string {
  const lines = [
    `Error report — ${resolveServiceName(entry.service_origin)}`,
    `Code:      ${entry.error_code}`,
    `Severity:  ${entry.severity}`,
    `When:      ${new Date(entry.timestamp).toISOString()}`,
    `Message:   ${entry.message}`,
  ];
  if (entry.session_id) lines.push(`Session:   ${entry.session_id}`);
  if (entry.occurrenceCount > 1) lines.push(`Count:     ${entry.occurrenceCount}`);
  if (entry.details && Object.keys(entry.details).length > 0) {
    lines.push('Details:');
    lines.push(JSON.stringify(entry.details, null, 2));
  }
  return lines.join('\n');
}

export function formatDetails(details: Record<string, unknown> | undefined): string | null {
  if (!details || Object.keys(details).length === 0) return null;
  return JSON.stringify(details, null, 2);
}
